<div *ngIf='formReady' [formGroup]='inputForm' class='ReleaseReplayAction'>
  <div class='row'>
    <div class='col col-3'>
      <mat-label>Note</mat-label>
    </div>
    <div class='col col-9'>
      <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig' formControlName='note'></app-editor>
    </div>
  </div>
  <div *ngIf='managerEmail' class='row'>
    <div class='col col-9 offset-3'>
      <mat-checkbox class='mt-3' formControlName='ccManager'
      >CC <span>{{ managerEmail }}</span></mat-checkbox
      >
    </div>
  </div>
</div>
